import { useMemo } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { formatNumber } from "../../../../utils/format";

const formatDayLabel = (dayKey) => {
  if (!dayKey) return "—";
  const [, month, day] = String(dayKey).split("-");
  if (!month || !day) return "—";
  return `${day}/${month}`;
};

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload || payload.length === 0) return null;
  const p = payload[0];
  return (
    <div className="bg-white border border-gray-200 rounded-md shadow-md px-2.5 py-2 text-xs">
      <div className="font-semibold text-gray-900">
        {formatDayLabel(p.payload.day)}
      </div>
      <div className="text-gray-600 mt-0.5">
        {formatNumber(p.value)} contacts mới
      </div>
    </div>
  );
};

const PipelineNewContactsChart = ({ series = [], loading }) => {
  const data = useMemo(
    () =>
      (series || []).map((r) => ({
        ...r,
        label: formatDayLabel(r.day),
      })),
    [series],
  );

  if (loading) {
    return <div className="h-[240px] bg-gray-50 rounded animate-pulse" />;
  }

  const totalInPeriod = data.reduce((sum, r) => sum + (Number(r.count) || 0), 0);

  if (!data || data.length === 0 || totalInPeriod === 0) {
    return (
      <div className="text-sm text-gray-500 py-8 text-center">
        Chưa có contact mới trong khoảng này
      </div>
    );
  }

  return (
    <div className="h-[240px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="pipelineNewContactsFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#3b82f6" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#3b82f6" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" vertical={false} />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: "#6b7280" }}
            tickLine={false}
            axisLine={{ stroke: "#e5e7eb" }}
            interval="preserveStartEnd"
            minTickGap={24}
          />
          <YAxis
            tick={{ fontSize: 11, fill: "#6b7280" }}
            tickLine={false}
            axisLine={false}
            allowDecimals={false}
            width={32}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ stroke: "#e5e7eb" }} />
          <Area
            type="monotone"
            dataKey="count"
            stroke="#3b82f6"
            strokeWidth={2}
            fill="url(#pipelineNewContactsFill)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PipelineNewContactsChart;
